import { useUserStore } from '@/store';
import type { PermRoleKey } from '@/types/permission';

/**
 * @description 判断当前用户Id是否有权限
 */
export function hasPermU(u: number | number[]) {
  const userStore = useUserStore();
  if (userStore.isRole('admin')) {
    // 默认 admin 拥有全部权限
    return true;
  }
  return userStore.isUserId(u);
}

/**
 * @description 判断当前用户角色是否有权限
 */
export function hasPermR(roles: PermRoleKey | PermRoleKey[]) {
  const userStore = useUserStore();
  if (userStore.isRole('admin')) {
    // 默认 admin 拥有全部权限
    return true;
  }
  if (Array.isArray(roles)) {
    return userStore.isRolesOne(roles);
  } else {
    return userStore.isRole(roles);
  }
}
